var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.autoBlock || _vm.edit)?_c('IconList',{ref:"child",attrs:{"block":_vm.autoBlock,"edit":_vm.edit},on:{"openIconListEditor":function($event){return _vm.$emit('openResultListEditor')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }